import { useEffect, useCallback, useRef } from 'react';

const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'KeyB',
  'KeyA',
];

export function useKonamiCode(callback: () => void) {
  const sequenceRef = useRef<string[]>([]);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // Clear timeout on each keypress
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Add key to sequence
      sequenceRef.current.push(event.code);

      // Keep only last 10 keys
      if (sequenceRef.current.length > 10) {
        sequenceRef.current.shift();
      }

      // Check if sequence matches
      if (sequenceRef.current.length === 10) {
        const matches = KONAMI_CODE.every(
          (key, index) => key === sequenceRef.current[index]
        );

        if (matches) {
          callback();
          sequenceRef.current = []; // Reset sequence
        }
      }

      // Reset sequence after 2 seconds of inactivity
      timeoutRef.current = setTimeout(() => {
        sequenceRef.current = [];
      }, 2000);
    },
    [callback]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [handleKeyDown]);
}
